var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 113,
    viewBox: "0 0 114 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_138_403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1531 93.99C22.6341 93.99 21.1234 93.575 19.787 92.7532C18.5849 92.0073 17.5927 90.9672 16.9043 89.7312C16.2159 88.4953 15.8539 87.1042 15.8525 85.6895V19.2854C15.8525 16.4051 17.3466 13.7323 19.787 12.2216C20.9918 11.4809 22.3651 11.0587 23.778 10.9948C25.1908 10.931 26.5967 11.2274 27.8634 11.8564L94.2675 45.0585C95.6462 45.7491 96.8056 46.8097 97.6158 48.1217C98.426 49.4338 98.8552 50.9454 98.8552 52.4874C98.8552 54.0294 98.426 55.5411 97.6158 56.8531C96.8056 58.1651 95.6462 59.2258 94.2675 59.9164L27.8634 93.1184C26.7013 93.6995 25.4147 93.99 24.1531 93.99Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_138_403",
    x: 0.961937,
    y: 0.120213,
    width: 112.784,
    height: 112.785,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 7.04285,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_138_403"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.02449
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.92387
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_138_403"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_138_403",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseIcon);
export default __webpack_public_path__ + "static/media/pause-icon.da681cba7eb7e81898ba678604ba866a.svg";
export { ForwardRef as ReactComponent };